export const content = `Find the instructions for your device. You can jump to your device's section using the side navigation on desktop or expanding the 'Articles in this section' on mobile.

## On iPhone and iPad

1. On your iPhone or iPad, open your device **Settings**.
2. Tap on **Privacy**.
3. Tap on **Microphone** or **Camera**.
4. Find Safari from the list. Tap to turn the microphone or camera on or off.

## On a Computer

1. Open Safari.
2. Go to a site that wants to use your microphone and camera.
3. When prompted, select **Allow**.

If you select “Never for this website” and deny access to your microphone or camera, you can allow a site to use them by going to **Preferences** > **Websites** > **Microphone** or **Camera** settings.

Change a site’s microphone or camera permissions to **Allow** or **Ask**, if you’d like to choose each time you visit.
`;
